module.exports = "<p *ngIf=\"_global.selectLang =='en'\" >Copyrights @ BAOMINH 2020</p>\n<p *ngIf=\"_global.selectLang =='vn'\">Bản quyền @ Bảo Minh 2020</p>\n"